import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FileService } from '../services/validation.service';
import { validationKeys } from './keys';
/**
 * Resolves an S3 object key to an object URL usable as an <img> src.
 * The fetched Blob is cached by key (no refetch on revisit), while the object URL is
 * created per consumer and revoked on unmount/key-change to avoid leaking URLs.
 */
export function useBlobImage(key) {
    const { data: blob, isLoading, isError } = useQuery({
        queryKey: validationKeys.blob(key || ''),
        queryFn: () => FileService.getBlob(key),
        enabled: !!key,
        staleTime: Infinity,
        gcTime: Infinity
    });
    const [url, setUrl] = useState();
    useEffect(() => {
        if (!blob) {
            setUrl(undefined);
            return;
        }
        const objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [blob]);
    return { url, isLoading, isError };
}
